import { enumToNameWithDefault, rawValueToEnumWithDefault } from '@ps-smart-cp/ppfw-client';
import { closingStatusNameConfig } from './ClosingStatus.name';

enum ClosingStatus {
  normal = 'NORMAL',
  provisionalCutoff = 'PROVISIONAL_CUTOFF',
  finalCutoff = 'FINAL_CUTOFF',
  afterClosing = 'AFTER_CLOSING',
  beforeStartOfFiscalYear = 'BEFORE_START_OF_FISCAL_YEAR',
}

const closingStatusMap = new Map([
  ['NORMAL', ClosingStatus.normal],
  ['PROVISIONAL_CUTOFF', ClosingStatus.provisionalCutoff],
  ['FINAL_CUTOFF', ClosingStatus.finalCutoff],
  ['AFTER_CLOSING', ClosingStatus.afterClosing],
  ['BEFORE_START_OF_FISCAL_YEAR', ClosingStatus.beforeStartOfFiscalYear],
]);

const closingStatusToDisplay = enumToNameWithDefault(ClosingStatus, closingStatusNameConfig);

const rawValueToClosingStatus = rawValueToEnumWithDefault(closingStatusMap, ClosingStatus.normal);

export { ClosingStatus, closingStatusToDisplay, rawValueToClosingStatus };
